 import React, { useEffect, useState } from "react";
import { Button, Card, Collapse, Pagination, Spinner, Table } from "react-bootstrap";
import ContainerDetailsPanel from '../Panel/Panel';
import './Table.scss';
import { McButton, McCard, McDialog, McIcon, McLoadingIndicator, McPagination, McTag } from "@maersk-global/mds-react-wrapper";
import { getToken } from "../../utils/token";
import { protectedResources } from "../../auth/auth-config";
// import { convertToCSV } from "../Panel/Panel";

export const formatDate = (dateString:string): string => {
    if(!dateString) return "N/A";
    const date=new Date(dateString);
    if(isNaN(date.getTime())) return "";
    const day=date.getDate();
    const monthNames=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const month=monthNames[date.getMonth()];
    const year=date.getFullYear();

    

    return `${day < 10 ? `0${day}` : day}-${month}-${year}`;
};

interface ContainerDetail {
    containerId: number;
    containerNumber: string;
    isReefer:string;
    bookingId: number;
    bookingNumber: string;
    transportationStatus:string;
    commodityName:string;
    operatorCode:string;
    transportStartDate: string | Date;
    customsSeal: string;
    shipperSeal: string;
    carrierSeal: string;
    veterinarySeal: string;
}

interface Props {
    containerDetails: ContainerDetail[];
}

const ContainerDetailsTable: React.FC<Props> = ({ containerDetails }) => {
    const [expandedBookings, setExpandedBookings] = useState<string[]>([]);
    const [selectedContainerId, setSelectedContainerId] = useState<number | null>(null);
    const [selectedBookingNumber, setSelectedBookingNumber] = useState<string| null>(null);
    const [selectedContainerNumber,setSelectedContainerNumber]= useState<string | null>(null);
    const [downloadProgress, setDownloadProgress]=useState<number>(0);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isReefer, setIsReefer] = useState<string | null>(null);
    const [loadingDownloads,setLoadingDownloads] = useState<string | null>(null);
    const [loadingJourneyLogDownloads, setLoadingJourneyLogDownloads] =useState<string | null>(null);
    const [collapsedbooking, setCollapsedBooking]=useState<string[]>([]);
    const [downloadMessage,setDownloadMessage]=useState<string | null>(null);
    const [isDialogOpen,setIsDialogOpen]=useState<boolean>(false);
    const [dialogMessage,setDialogMessage]=useState<string>("");
    const [showProgressBar,setShowProgressBar]=useState<boolean>(false);
    const rowsPerPage=5;

   

 useEffect(()=>{
    if(containerDetails.length>0){
        const allBookingNumbers=containerDetails.map((detail)=>detail.bookingNumber);
        setExpandedBookings(allBookingNumbers);
    }
 },[containerDetails]);

    const toggleBooking = (bookingNumber: string) => {

        const controlScrollPosition=window.scrollY;
        setExpandedBookings((prev) =>
          prev.includes(bookingNumber)
            ? prev.filter((num) => num !== bookingNumber)
            : [...prev, bookingNumber]
        );
        setCollapsedBooking((prev)=>
        prev.includes(bookingNumber)
    ? prev.filter((num)=>num!=bookingNumber)
:[...prev,bookingNumber]);
        setTimeout(()=>{
            window.scrollTo(0,controlScrollPosition);
        },0);
      };
    

    const handleViewClick = (containerId: number,bookingNumber:string,containerNumber:string,isReefer:string) => {
        setSelectedContainerId(containerId);
        setSelectedBookingNumber(bookingNumber);
        setSelectedContainerNumber(containerNumber);
        setIsReefer(isReefer);
        setIsReefer(isReefer);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedContainerId(null);
        setSelectedContainerNumber(null);
        setSelectedBookingNumber(null);
        setIsReefer(null);
    };

    const handlePageChange=(page:number) => {
        setCurrentPage(page);
        window.scrollTo(0,0);
    }
    
    // const handleDownloadClick =async (containerNumber:string, operatorCode:string,bookingNumber:string) => {
    //     setLoadingDownloads(bookingNumber);
    //     setDownloadMessage("Download is in progress. It may take a while.");
    //     setDownloadProgress(100);
    //     const progressInterval=setInterval(()=>{
    //         setDownloadProgress((prev)=>(prev>10?prev-1:prev));
    //     },100);
    //     try {
           
    //         const accessToken = await getToken(protectedResources.sherlock.scopes.read);
    //         console.log('Access Token:', accessToken);
        
    //         const apiUrl = `https://sherlock-dev.maersk.com/api/Container/DownloadBookingDocsAsync/`;

    //         const  containersForBooking = containerDetails.filter((detail) => detail.bookingNumber === bookingNumber)
    //         .map((detail)=>detail.containerNumber);
    //         const payload = {
    //             ContainerNumber:containersForBooking,
    //             BookingNumber:"BLGOV0210",
    //             Carrier:"MAEU",
    //         };
    //         const zipRequest = await fetch(apiUrl, {
    //             method: 'POST',
    //             headers: {
    //                 Authorization: `Bearer ${accessToken}`,
    //                 Accept: 'application/zip', 
    //                 'Content-Type':'application/json',
    //             },
    //             body: JSON.stringify(payload),
    //         });
    //         const journeyLogPayload ={containerNumber:containersForBooking,bookingNumber};
    //         const journeyLogRequest=await postAPI("api/Container/GetContainerJourneyDetailsAsync/",journeyLogPayload);
           
    //         const [zipResponse,journeyLogData]=await Promise.all([zipRequest,journeyLogRequest]);
    
    //         if (zipResponse.ok && zipResponse.headers.get('Content-Type') === 'application/zip') {
    //             const zipBlob = await zipResponse.blob();
    //             const zip=await JSZip.loadAsync(zipBlob);

    //             if(journeyLogData){
    //                 containersForBooking.forEach((containerNumber)=>{
    //                     const containerLog = journeyLogData.filter(
    //                         (log) => log.containerNumber === containerNumber
    //                     );
                    
    //                 const journeyLogCSV=convertToCSV(containerLog);
    //                 const journeyBlob= new Blob([journeyLogCSV],{type:"text/CSV"});
    //                 const journeyFilename=`${containerNumber}_JourneyLog.csv`;

    //              zip.file(journeyFilename,journeyBlob);
    //             });
    //         }

                
    //              const updatedZipFile=await zip.generateAsync({type:"blob"});
    //              const updatedZipUrl=window.URL.createObjectURL(updatedZipFile);
    //             const a = document.createElement('a');
    //             a.href = updatedZipUrl;
    //             a.download = `${containerNumber}_.zip`;
    //             document.body.appendChild(a);
    //             a.click();
    //             document.body.removeChild(a);
    //             window.URL.revokeObjectURL(updatedZipUrl);
    //         } else {
    //             const textResponse = await zipResponse.text();
    //             console.error('Unexpected response:', textResponse);
    //             throw new Error('Failed to download ZIP file. Please check the API endpoint and authentication.');
    //         }
            
    //     } catch (error) {
    //         console.error('Error downloading file:', error);
    //         // alert('Failed to download the file. Please try again.');
    //         setDialogMessage("Failed to download the file. Please try again.");
    //         setIsDialogOpen(true);
    //     }finally{
    //         clearInterval(progressInterval);
    //         //setDownloadProgress(100);
    //         setTimeout(()=> {
    //             setLoadingDownloads(null);
    //             setDownloadMessage(null);
    //             setDownloadProgress(0);
    //         },500);
           
    //     }
    // };

    const handleDownloadBillOfLadingDocs=async (bookingNumber: string) => {
        setLoadingDownloads(bookingNumber);
        setDownloadMessage("Downloading Bill of Lading. It may take a while.");
        setDownloadProgress(100);
        setShowProgressBar(true);
        
        const progressInterval = setInterval(()=>{
            setDownloadProgress((prev)=>(prev>10?prev-1:prev));
        },100);

        try{
            const accessToken=await getToken(protectedResources.sherlock.scopes.read);
            console.log("Access Token:",accessToken);
            const apiUrl=`${process.env.REACT_APP_API_BASE_URL}/api/Container/DownloadBillOfLadingBookingDocsAsync/`;
            const containersForBooking = containerDetails.filter((detail) => detail.bookingNumber === bookingNumber);
            const operatorCode = containersForBooking[0]?.operatorCode || "UNKNOWN";
            const containerNumbers = containersForBooking.map((detail) => detail.containerNumber);
            const payload={
                containerNumber:containerNumbers,
                bookingNumber:bookingNumber,
                carrier:operatorCode
            };
            const pdfRequest = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                Authorization: `Bearer ${accessToken}`,
                Accept: 'application/pdf', 
                'Content-Type':'application/json',
            },
                body: JSON.stringify(payload),
            });
            if(pdfRequest.ok && pdfRequest.headers.get('Content-Type') === 'application/pdf'){
                const pdfBlob=await pdfRequest.blob();
                downloadFile(pdfBlob, `${bookingNumber}.pdf`);
            }else{
                // const textResponse= await zipRequest.text();
                // console.error('Unexpected response:',textResponse);
                // throw new Error('Failed to download Zip File');
                const errorResponse = pdfRequest.clone(); 
                throw errorResponse;
            }
            }catch (error){
               handleDownloadError(error);
            }finally{
                clearInterval(progressInterval);
                setTimeout(()=>{
                    setLoadingDownloads(null);
                    setDownloadMessage(null);
                    setDownloadProgress(0);
                    setShowProgressBar(false);
                },500);
            }
        };

        const downloadFile = (blob:Blob, filename: string) => {
            const url=window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href=url;
            a.download=filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        };

    const handleDownloadJourneyLog=async (bookingNumber:string) => {
        setLoadingJourneyLogDownloads(bookingNumber);
        setDownloadMessage("Downloading Booking Details and Journey Log. It may take a while.");
        setShowProgressBar(true);
        setDownloadProgress(100);

        const progressInterval=setInterval(()=>{
            setDownloadProgress((prev)=>(prev>10?prev-1:prev));

        },100);
        try{
            const containersForBooking=containerDetails.filter((detail)=>detail.bookingNumber === bookingNumber)
            .map((detail)=>detail.containerNumber);

            const payload = {containerNumber:containersForBooking,bookingNumber};
            const accessToken = await getToken(protectedResources.sherlock.scopes.read);
            console.log("Access Token:", accessToken);
            const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/Container/DownloadJourneyLogAsync`;
            const zipRequest = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    Accept: 'application/zip',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            console.log("Response Status:", zipRequest.status);
            console.log("Response Headers:", zipRequest.headers);
            if (zipRequest.ok && zipRequest.headers.get('Content-Type') === 'application/zip') {
                const zipBlob = await zipRequest.blob();

                console.log("Zip Blob object:", zipBlob); 
                console.log("Zip Blob size:", zipBlob.size); 
    

                if (zipBlob.size === 22) {
                    console.log("Zip Blob object:", zipBlob); 
                    console.log("Zip Blob size:", zipBlob?.size); 
                    setDownloadMessage("Journey Log not found.");
                    setShowProgressBar(false);
                    setTimeout(() => setDownloadMessage(null), 15000);
                    return;
                }
    
                downloadZipFile(zipBlob, `${bookingNumber}.zip`);
            } else {
                const textResponse = await zipRequest.text();
                console.error('Unexpected response:', textResponse);
                throw new Error('Failed to download Journey Log zip file.');
            }
        } catch (error) {
            handleDownloadError(error);
        } finally {
            clearInterval(progressInterval);
            setTimeout(() => {
                setLoadingJourneyLogDownloads(null);
                setDownloadMessage(null);
                setDownloadProgress(0);
                setShowProgressBar(false);
            }, 1000);
        }
    };
    const downloadZipFile = (blob:Blob,filename:string) => {
        const url=window.URL.createObjectURL(blob);
        const a=document.createElement('a');
        a.href=url;
        a.download=filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }
    // const handleDownloadError=(error:any)=>{
    //     console.error('Error downloading file:',error);
    //     setDialogMessage('Failed to download the file. Please try again.');
    //     setIsDialogOpen(true);
    // }
    const handleDownloadError = async (error: any) => {
        console.error('Error downloading file:', error);
    
        try {
            if (error instanceof Response) {
                const errorText = await error.text();
                if (errorText.includes('Status Code: NotFound')) {
                    setDialogMessage('Bill of Lading cannot be found for this Booking Number.');
                } else if (errorText.includes('No files found for docBrokerId')){
                     setDialogMessage('Bill of Lading cannot be found for this Booking Number.')
                }
                 else {
                    setDialogMessage('Failed to download the file. Please try again.');
                }
            } else {
               
                setDialogMessage('Failed to download the file. Please try again.');
            }
        } catch (parseError) {
            console.error('Error parsing error response:', parseError);
            setDialogMessage('An unexpected error occurred. Please try again.');
        }
    
        setIsDialogOpen(true);
    };
    const sortedContainerDetails = [...containerDetails].sort(
        (a, b) => new Date(b.transportStartDate).getTime() - new Date(a.transportStartDate).getTime()
      );
    const groupedData = sortedContainerDetails.reduce((acc, detail) => {
        const { bookingNumber } = detail;
        if (!acc[bookingNumber]) {
          acc[bookingNumber] = [];
        }
        acc[bookingNumber].push(detail);
        return acc;
      }, {} as Record<number, ContainerDetail[]>);

     

      
    const totalPages=Math.ceil(Object.keys(groupedData).length/rowsPerPage);
    

    useEffect(()=>{
        if(currentPage>totalPages && totalPages>0){
            setCurrentPage(totalPages);
        }else if (currentPage<1){
            setCurrentPage(1);
        }
    },[currentPage,totalPages]);

      const indexOfLastRow=currentPage * rowsPerPage;
      const indexOfFirstRow=indexOfLastRow-rowsPerPage;
     //  const currentRows=containerDetails.slice(indexOfFirstRow,indexOfLastRow);
     const sortedGroupedData = Object.entries(groupedData).sort(
        ([, a], [, b]) =>
          new Date(b[0].transportStartDate).getTime() - new Date(a[0].transportStartDate).getTime()
      );
      
     const currentRows=sortedGroupedData.slice(indexOfFirstRow, indexOfLastRow);
     
     return (
        <div className="grouped-container-details">
            {downloadMessage && (
                <div className="sticky-note">
                    {downloadMessage}
                    {showProgressBar && (
                    <div className="progress-bar">
                        <div className="progress" style={{width: `${downloadProgress}%`}}></div>
                    </div>
                    )}
           </div>
            )}
        {currentRows.map(([bookingNumber,details]) => (
         <Card className="mb-3 card-small"  key={bookingNumber}>
                <Card.Header className={`d-flex justify-content-between align-items-center ${collapsedbooking.includes(bookingNumber) ? 'collapsed' : ''}`}>
    <div>
        <span>Booking Number: 
            <span className="booking-number">{bookingNumber}</span>
            </span>
    </div>
    <div className="actions d-flex align-items-center">
    <span
                               onClick={(e)=>{
                                e.preventDefault();
                                handleViewClick(details[0].containerId,bookingNumber,details[0].containerNumber,details[0].isReefer);
                               }}
                               className="icon-action view-icon"
                               style={{cursor:"pointer",marginRight:"10px"}}
                               title="View"
                               >
                                <McIcon className="icon-action view-icon" icon="file-eye" />
                               </span>

                               <span 
                               onClick={(e)=>{
                                e.preventDefault();
                                handleDownloadBillOfLadingDocs(bookingNumber);
                               }}
                               className="icon-action download-icon"
                               style={{cursor:"pointer",marginRight:"10px"}}
                               title="Bill of Lading"
                               >
                                {loadingDownloads === bookingNumber ?(
                                    <McLoadingIndicator appearance="primary" hiddenlabel />
                                ):(
                                    <McIcon className="icon-action" icon="file-pdf"></McIcon>
                                
                                )}
                               </span>
                               <span 
                               onClick={(e)=>{
                                e.preventDefault();
                                handleDownloadJourneyLog(bookingNumber);
                               }}
                               className="icon-action download-icon"
                               style={{cursor:"pointer",marginRight:"0"}}
                               title="Booking Details and Journey Log"
                               >
                                {loadingJourneyLogDownloads === bookingNumber ?(
                                    <McLoadingIndicator appearance="primary" hiddenlabel />
                                ):(
                                    <McIcon className="icon-action" icon="file-excel"></McIcon>
                                
                                )}
                               </span>
                               
                                {/* <span onClick={(e)=>{
                                    e.preventDefault();
                                    handleDownloadClick(details[0].containerNumber,details[0].operatorCode,bookingNumber);
                                }}
                                className="icon-action download-icon"
                                style={{cursor:"pointer"}}
                                title="Download">
                                    {loadingDownloads === bookingNumber ?(
                                    //  <Spinner animation='border' role='status' className='custom-spinner' style={{ width: '1.3rem', height: '1.3rem' }}></Spinner>
                                    <McLoadingIndicator appearance="primary" hiddenlabel />
                                    ):( 
                                <McIcon icon="arrow-to-bottom"></McIcon>
                                    )}
                                </span> */}

        <a
            href="#"
            onClick={(e) => {
                e.preventDefault();
                toggleBooking((bookingNumber));
            }}
            className="dropdown-icon me-3"
        >
            <McIcon
                icon={expandedBookings.includes((bookingNumber)) ? "chevron-up" : "chevron-down"}
            />
        </a>
    </div>
</Card.Header>  
                <Collapse in={expandedBookings.includes((bookingNumber))}>
                    <Card.Body>
                   
                    <div className="headings-row">
                        <span>Container Number</span>
                        <span>Transportation Status</span>
                        <span>Commodity Name</span>
                        <span>Operator Code</span>
                        <span>Transport Start Date</span>
                        <span>Reefer</span>
                        <span>Shipper Seal</span>
                        <span>Carrier Seal</span>
                        <span>Customs Seal</span>
                        <span>Veterinary Seal</span>
                    </div>
                    {/* Render details for each row */}
                    {details.map((detail) => (
                        <div key={detail.containerId} className="detail-row">
                            <div><strong>{detail.containerNumber}</strong></div>
                            <div>
                                <McTag
                                appearance={
                                    detail.transportationStatus === "Active" ? "info"
                                    : detail.transportationStatus === "Migrated Off" ? "neutral-weak"
                                    : detail.transportationStatus === "Cancelled by Carrier" ? "warning"
                                    : detail.transportationStatus === "Completed" ? "success"
                                    : detail.transportationStatus === "Abandoned" ? "error"
                                    : detail.transportationStatus === "Cancelled by Customer" ? "warning"
                                    : "neutral-weak"
                                }
                                fit="small"
                                dismiss={()=>{}}
                                >
                                {detail.transportationStatus}
                                </McTag>
                            </div>
                            {/* <div>{detail.commodityName}</div> */}
                            <div className="commodity-name" title={detail.commodityName || ''}>
                                {(detail.commodityName || '').split(" ").slice(0,17).join(" ")}
                                <span className="commodity-name-full">{detail.commodityName || ''}</span>
                            </div>
                            <div><strong>{detail.operatorCode}</strong></div>
                            <div><strong>{formatDate(detail.transportStartDate as string)}</strong></div>
                            <div><strong>{detail.isReefer}</strong></div>
                            <div title={detail.shipperSeal || ''}>
                                {detail.shipperSeal ? <strong>{detail.shipperSeal}</strong> : ''}
                            </div>
                            <div title={detail.carrierSeal || ''}>
                                {detail.carrierSeal ? <strong>{detail.carrierSeal}</strong> : ''}
                            </div>
                            <div title={detail.customsSeal || ''}>
                                {detail.customsSeal ? <strong>{detail.customsSeal}</strong> : ''}
                            </div>
                            <div title={detail.veterinarySeal || ''}>
                                {detail.veterinarySeal ? <strong>{detail.veterinarySeal}</strong> : ''}
                            </div>
                        </div>
                    ))}
                    </Card.Body>
                </Collapse>
            </Card>

     
       
        ))}
            <div className="pagination-container" style={{ marginTop: '20px' }}>
            <McPagination
                totalpages={totalPages}
                currentpage={currentPage}
                visiblepages={5} 
                pagechange={(e: CustomEvent) => handlePageChange(Number(e.detail))}
            />
        </div>

        {isDialogOpen && (
            <McDialog
                heading={ dialogMessage === 'Bill of Lading cannot be found for this Booking Number.'
                    ? 'Information'
                    :'Download Failed'
                }
                body={dialogMessage}
                zindex={99999}
                open={isDialogOpen}
                closed={() => setIsDialogOpen(false)}
                click={() => setIsDialogOpen(false)}
                closing={() => { }}
            >
                <McButton slot="primaryAction" appearance="neutral" dialogaction="cancel" onClick={() => setIsDialogOpen(false)}>
                    Close
                </McButton>
            </McDialog>
        )}
       
        <ContainerDetailsPanel
            isOpen={isModalOpen}
            containerId={selectedContainerId}
            containerNumber={selectedContainerNumber}
            bookingNumber={selectedBookingNumber ? selectedBookingNumber.toString() : null}
            isReefer={isReefer}
            containerNumbers={containerDetails.map((detail) => detail.containerNumber)}
            onClose={handleCloseModal}
        />
    </div>
);
};

export default ContainerDetailsTable;
